module.exports = __webpack_public_path__ + "media/images/countrysquared/md-ace9e5786b043848aee2fdb572e7e6ba.svg";